/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CommodityDetailIngotWeight = (typeof CommodityDetailIngotWeight)[keyof typeof CommodityDetailIngotWeight];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommodityDetailIngotWeight = {
  weight_1g: "weight_1g",
  weight_2g: "weight_2g",
  weight_2g5: "weight_2g5",
  weight_5g: "weight_5g",
  weight_10g: "weight_10g",
  weight_20g: "weight_20g",
  weight_31g1: "weight_31g1",
  weight_50g: "weight_50g",
  weight_100g: "weight_100g",
  weight_250g: "weight_250g",
} as const;
